import db from "../../utils/firebase.config";
import "./style.css";
import { collectionGroup, getDocs, query, where } from "firebase/firestore";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import foto from './background.jpg'

const Login = () => {
  const backgroundImage = `url(${foto})`;

  const form = useRef(null);

  const [messageError, setMessageError] = useState("");

  const [validateIsNumber, setValidateIsNumber] = useState(false);

  const [ifBlankBox, setIfBlankBox] = useState(false);

  const navigate = useNavigate();

  const setNumber = (dato) => {
    let valoresAceptados = /^[0-9]+$/;
    if (dato.match(valoresAceptados) && dato.length === 10) {
      setValidateIsNumber(false);
      setMessageError("");
    } else {
      setValidateIsNumber(true);
      setMessageError("Introduzca solo números (10 digitos)");
    }

    if (dato === "") {
      setValidateIsNumber(false);
    }
  };

  const findNumber = async (e) => {
    e.preventDefault();
    setIfBlankBox(false);

    const newForm = new FormData(form.current);
    const Data = {
      numberForm: newForm.get("numberForm"),
    };

    const guessQuery = query(
      collectionGroup(db, "guess"),
      where("mobile", "==", Data.numberForm)
    );
    const querySnapshot = await getDocs(guessQuery);

    if (querySnapshot.empty) {
      setMessageError("No se encontró número");
      setIfBlankBox(true);
      return;
    }

    if (querySnapshot.size > 1) {
      setMessageError(
        "Número duplicado detectado. Contacta al administrador para corregir la base de datos."
      );
      setIfBlankBox(true);
      return;
    }

    const guestDoc = querySnapshot.docs[0];
    const invitationId = guestDoc.ref.parent.parent?.id;
    const guestData = guestDoc.data();

    if (!invitationId || !guestData?.slug) {
      setMessageError("No se pudo resolver la invitación para este número");
      setIfBlankBox(true);
      return;
    }

    form.current.reset();
    navigate(`/invitacion/${guestData.slug}/${invitationId}`);
  };

  return (
    <section id="login" className="section-bg" style={{ backgroundImage }}>
      <div className="container" data-aos="fade-up">
        <div className="text-center">
          <h2 className="section-subtitle login-title">Invitación</h2>
          <h3 className="login-sub-title">
            Por favor ingresa tu número de teléfono
          </h3>
        </div>

        <form onSubmit={findNumber} ref={form}>
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-10 d-flex">
              <input
                type="text"
                name="numberForm"
                inputMode="numeric"
                maxLength="10"
                minLength="10"
                autoComplete="on"
                // required
                className="form-control-login"
                placeholder="10 Digitos tel"
                onChange={(e) => setNumber(e.target.value)}
              />
            </div>
            {validateIsNumber && (
              <div className="mandatory-field">
                <p>{messageError}</p>
              </div>
            )}
          </div>
          {ifBlankBox && (
            <div className="mandatory-field">
              <p>{messageError}</p>
            </div>
          )}
          <div className="form">
            <div className="php-email-form-login text-center">
              <button type="submit">Entrar</button>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Login;
